import React from 'react';

import SubjectPage from '../subjects/SubjectPage';



function Mindmap() {

  
  const pageTitleText = "NEET Mind Maps ";


  return (
    <>
    

      <SubjectPage 
        name={pageTitleText} 
        link="mindmaps" 
        type="mindmap"
      />

    </>
  );
}

export default Mindmap;